import { FormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { UserType } from '../model/user.model';

export class UserFormValidationsHelper {
  static applyEnelEmployeeIdValidation(userForm: UntypedFormGroup, userType: string, isEdit: boolean = false): boolean {
    const enelIdControlExists = !!userForm.get('enel_employee_id');
    if (userType === UserType.INTERNAL) {
      if (!enelIdControlExists) {
        userForm.addControl('enel_employee_id', new FormControl('', Validators.required));
      } else if (isEdit) {
        const enelEmployeeId = userForm.get('enel_employee_id') as FormControl;
        enelEmployeeId.markAsTouched();
        enelEmployeeId.markAsDirty();
        enelEmployeeId.updateValueAndValidity();
      }
      return true;
    } else {
      if (enelIdControlExists) {
        userForm.removeControl('enel_employee_id');
      }
      return false;
    }
  }
}
